import { useMemo, useState } from "react";
import { Slider } from "@/components/ui/slider";
import { inr } from "@/lib/format";

export const onRoadBreakdown = (price, powertrain, o) => {
  const ev = powertrain === "EV";
  const rto = Math.round((price * (ev ? o.rto_pct_ev : o.rto_pct_ice)) / 100);
  const insurance = ev ? o.insurance_ev : o.insurance_ice;
  return { rto, insurance, handling: o.handling, total: price + rto + insurance + o.handling };
};

export const OnRoadTile = ({ price, m, settings, t }) => {
  const b = onRoadBreakdown(price, m.powertrain, settings.onroad);
  const rows = [[t("exShowroom"), price], [t("rto"), b.rto], [t("insurance"), b.insurance], [t("handling"), b.handling]];
  return (
    <div className="tile col-span-12 flex flex-col justify-between p-7 lg:col-span-4 pk:!col-span-6" data-testid="onroad-tile">
      <span className="text-[15px] font-medium text-[#6E6E73]">{t("onRoad")}</span>
      <div className="mt-3 divide-y divide-[#E5E5EA] text-[15px]">
        {rows.map(([l, v]) => <div key={l} className="flex justify-between py-2"><span className="text-[#6E6E73]">{l}</span><span className="tnum">{inr(v)}</span></div>)}
      </div>
      <div className="mt-3 flex items-end justify-between">
        <span className="text-[15px] font-semibold">{t("onRoadTotal")}</span>
        <span className="font-display text-3xl font-extrabold tracking-[-0.03em] tnum" data-testid="onroad-total">{inr(b.total)}</span>
      </div>
      <p className="mt-2 text-[12px] text-[#6E6E73]">{t("indicative")}</p>
    </div>
  );
};

export const EvSavingsTile = ({ m, settings, t }) => {
  const [km, setKm] = useState(30);
  const c = settings.ev_costs;
  const calc = useMemo(() => {
    const month = km * 30;
    const petrol = (month / c.ice_ref_kmpl) * c.petrol_price;
    const charge = month * (m.specs.battery_kwh / m.specs.range_km) * c.electricity_tariff;
    return { petrol, charge, saved: petrol - charge };
  }, [km, c, m]);
  return (
    <div className="tile col-span-12 grid gap-6 p-7 lg:col-span-8 lg:grid-cols-[1fr_1.1fr] pk:!col-span-12" data-testid="ev-savings-tile">
      <div>
        <span className="text-[15px] font-medium text-[#6E6E73]">{t("evSavings")}</span>
        <p className="mt-4 font-display text-[52px] font-extrabold leading-none tracking-[-0.04em] text-[#087568] tnum" data-testid="ev-saved">{inr(calc.saved)}</p>
        <p className="mt-2 text-[15px]">{t("savedMonth")}</p>
        <p className="mt-2 text-[12px] text-[#6E6E73]">{t("petrol")} ₹{c.petrol_price}/l · {c.ice_ref_kmpl} km/l · {t("charging")} ₹{c.electricity_tariff}/kWh · {t("indicative")}</p>
      </div>
      <div className="flex flex-col justify-center gap-6">
        <div>
          <div className="mb-4 flex justify-between text-[15px]"><span className="text-[#6E6E73]">{t("dailyRide")}</span><span className="font-semibold tnum" data-testid="ev-km">{km} km</span></div>
          <Slider className="kiosk-slider" value={[km]} min={5} max={120} step={5} onValueChange={(v) => setKm(v[0])} data-testid="ev-km-slider" />
        </div>
        <div className="grid grid-cols-2 gap-3 text-[15px]">
          <div className="rounded-2xl bg-white p-4"><p className="text-[#6E6E73]">{t("petrol")}</p><p className="font-semibold tnum">{inr(calc.petrol)}{t("perMonthShort")}</p></div>
          <div className="rounded-2xl bg-white p-4"><p className="text-[#6E6E73]">{t("charging")}</p><p className="font-semibold tnum">{inr(calc.charge)}{t("perMonthShort")}</p></div>
        </div>
      </div>
    </div>
  );
};
